module.exports = __webpack_public_path__ + "img/3_103.a031651c.png";